module.exports = __webpack_public_path__ + "img/LUTOP_Logo_System.5ffa084e.svg";